export default [
  {
    title: 'Dev Tickets',
    excerpt: 'Submit a bug ticket for the development team',
    department: 'dev',
    image: 'https://www.ibeta.com/wp-content/uploads/2019/06/software-bugs.jpg',
    url: 'https://form.asana.com?k=PLmVGLVwzZAzK_RTqyussQ&d=57531557960950',
  },
  {
    title: 'Screen Printing',
    excerpt: 'Submit a new screen printing job',
    department: 'graphics & print',
    image: 'https://sc04.alicdn.com/kf/HTB1szeweRaE3KVjSZLeq6xsSFXaQ.jpg',
    url: 'https://form.asana.com/?k=yMByaxEY8BuZcsqvc1mE1Q&d=57531557960950',
  },
  // {
  //   title: 'Feature Request',
  //   excerpt: 'Submit a new idea or feature for DEV',
  //   department: 'dev',
  //   image:
  //     'https://www.cflowapps.com/wp-content/uploads/2020/04/features-of-back-office-software.png',
  //   url: '',
  // },
];



// WEBPACK FOOTER //
// ./src/data/forms.js